import {Component, OnDestroy, OnInit} from '@angular/core';
import {DashboardSectionOptions} from '../../dashboard-section/dashboard-section-options';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-example-bar-widget',
  templateUrl: './example-bar-widget.component.html',
  styleUrls: ['./example-bar-widget.component.scss']
})
export class ExampleBarWidgetComponent implements OnInit, OnDestroy {

  data = [{
    day: 'Monday',
    oranges: 3
  }, {
    day: 'Tuesday',
    oranges: 2
  }, {
    day: 'Wednesday',
    oranges: 3
  }, {
    day: 'Thursday',
    oranges: 4
  }, {
    day: 'Friday',
    oranges: 6
  }, {
    day: 'Saturday',
    oranges: 11
  }, {
    day: 'Sunday',
    oranges: 4
  }];
  private sub: Subscription;

  constructor(private options: DashboardSectionOptions) {
  }

  ngOnInit(): void {
    this.sub = this.options.change$.subscribe((d) => {
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

}
